export const PACKAGE_NAME = 'jsmImporterSurvey';
export const PACKAGE_TEAM_NAME = 'itops-mithril';
